function FileState (id) {
  this.id = id
}
FileState.prototype[Symbol.toStringTag] = 'FileState'
FileState.prototype.equals = function (state) {
  return this.id === (state.id === undefined ? state : state.id)
}
FileState.prototype.toString = function () {
  return this.id
}

export default {
  pending: new FileState('pending'),
  uploading: new FileState('uploading'),
  downloading: new FileState('downloading'),
  completed: new FileState('completed'),
  error: new FileState('error'),
  canceled: new FileState('canceled')
}



// WEBPACK FOOTER //
// ./src/plugins/uploader/file-states.js